import ActionType from 'actions/ActionType'
import { REQUEST, FAILURE } from 'utils/statusConstants'

export default (state = {}, action) => {
  switch (action.type) {
    case ActionType.Inbox.READ_EMAIL_REQUEST:
      return {
        ...state,
        [action.endpoint]: REQUEST,
      }
    case ActionType.Inbox.READ_EMAIL_SUCCESS:
      if (action.payload && action.payload.full_email_uri) {
        return {
          ...state,
          [action.payload.full_email_uri]: action.payload,
        }
      }
      return state
    case ActionType.Inbox.READ_EMAIL_FAILURE:
      return {
        ...state,
        [action.endpoint]: FAILURE,
      }
    default:
      return state
  }
}
